import { getValuesFromOptions } from './getValuesFromOptions';
import { toTimestamp } from './toTimeStamp';

const managerStatus = status => {
  if (status === null) {
    return null;
  }
  if (status?.includes('Not')) {
    return false;
  } else {
    return true;
  }
};

function formatRuleFilters(ruleFilters, initializeData) {
  const countriesList = getValuesFromOptions(ruleFilters.countries, initializeData.countries);
  const metricNamesList = getValuesFromOptions(
    [ruleFilters.metricName],
    initializeData.metricNames,
  );
  const dateOperatorList = getValuesFromOptions(
    [ruleFilters.dateOperator],
    initializeData.conditionOperators,
  );
  const metricOperatorList = getValuesFromOptions(
    [ruleFilters.metricOperator],
    initializeData.conditionOperators,
  );
  const hireDateTimeStamp =
    ruleFilters.lastHireDateInMillis != '' ? toTimestamp(ruleFilters.lastHireDateInMillis) : null;
  const hireEndDateTimeStamp =
    ruleFilters.lastHireEndDateInMillis != ''
      ? toTimestamp(ruleFilters.lastHireEndDateInMillis)
      : null;
  const isManagerBool = managerStatus(ruleFilters.isManager);

  return {
    leaderJobLevel: ruleFilters.leaderJobLevel,
    targetEmployeeJobLevels: ruleFilters.employeeJobLevels,
    countries: countriesList,
    leaderLogins: ruleFilters.leaderLogins,
    isManager: isManagerBool ? isManagerBool : ruleFilters.isManager === null ? null : false,
    lastHireDateInMillis: hireDateTimeStamp,
    dateOperator: ruleFilters.dateOperator ? dateOperatorList?.[0] : '',
    lastHireEndDateInMillis: hireEndDateTimeStamp,
    metricValue: ruleFilters.metricValue,
    metricOperator: ruleFilters.metricOperator ? ruleFilters.metricOperator : '',
    metricName: ruleFilters.metricName ? metricNamesList?.[0] : '',
    metrics: ruleFilters.metrics ?? [],
    isDirectReport: ruleFilters.isDirectReport,
  };
}

export default formatRuleFilters;
